type ProgressBarProps = {
  steps: { label: string; icon: React.ReactNode }[];
  currentStep: number;
};

const ProgressBar = ({ steps, currentStep }: ProgressBarProps) => {
  if (!steps || steps.length === 0) {
    return null;
  }

  const safeStepIndex = Math.min(Math.max(currentStep, 0), steps.length - 1);
  const activeStep = steps[safeStepIndex];

  return (
    <div className="w-full">
      {/* Mobile view: show only current step */}
      <div className="flex md:hidden justify-center items-center gap-2 p-3 bg-gray-50 text-md font-bold text-primary-600">
        <span>
          {`Etapa ${safeStepIndex + 1} de ${steps.length} - ${activeStep.label}`}
        </span>
        <div className="text-lg">{activeStep.icon}</div>
      </div>

      {/* Desktop view: full progress bar */}
      <div className="hidden md:flex flex-row justify-center items-center gap-2 px-4 bg-gray-50">
        {steps.map((step, index) => {
          const isActive = index === safeStepIndex;
          const isCompleted = index < safeStepIndex;

          return (
            <div 
              key={step.label} 
              className="flex items-center gap-2 text-xs sm:text-sm"
            >
              <div 
                className={`flex items-center gap-2 px-2 ${
                  isActive 
                    ? "text-primary-600 font-bold" 
                    : isCompleted 
                    ? "text-primary-600" 
                    : "text-gray-300"
                }`}
              >
                <div className={`text-md ${isActive ? "scale-110" : ""}`}>
                  {step.icon}
                </div>
                <span>{step.label}</span>
              </div>

              {index < steps.length - 1 && (
                <div 
                  className={`w-2 sm:w-6 h-0.5 mx-2 sm:mx-3 ${
                    isActive 
                    ? "bg-gray-300" 
                    : isCompleted 
                    ? "bg-primary-600" 
                    : "bg-gray-300"
                  }`} />
              )}
            </div>
          );
        })}
      </div>
    </div> 
  );
};

export default ProgressBar;
